import React from 'react';
import { Header } from '../../shared/layout/Header';
import { HeroSection } from './components/HeroSection';
import { TodaysGames } from './components/TodaysGames';
import { WhatIsTribe } from './components/WhatIsTribe';
import { LeaderboardPreview } from './components/LeaderboardPreview';
import { FooterCTA } from './components/FooterCTA';

export default function Home() {
  return (
    <div style={{ backgroundColor: '#151515', minHeight: '100vh' }}>
      <Header />
      <HeroSection />
      <TodaysGames />
      <LeaderboardPreview />
      <WhatIsTribe />
      <FooterCTA />
    </div>
  );
}
